module.exports = __webpack_public_path__ + "img/img_brand27.9bb44c9c.jpg";